/* eslint-disable max-lines-per-function, max-statements */
import useCreateReviews from "hooks/useCreateReviews";
import usePreviews from "hooks/usePreviews";
import useReviews from "hooks/useReviews";
import { useCallback, useEffect } from "react";
const useAddEditHomeVideoReview = () => {
    const { resetImages } = usePreviews();
    const { clearAll, setSelectedIsReviewCreated, state: { homeVideoReview } } = useReviews();
    const { avForumsData, avNirvanaData, avsForumData, bluRayAuthorityData, bluRayData, digitalBitsData, doBluData, hidefDigestData, highDefDiscNewsData, homeTheaterForumData, theaterByteData, whySoBluData } = useCreateReviews();
    useEffect(() => {
        if (avForumsData?.addReview && !homeVideoReview.avForumsId) {
            const { addReview: { id, serviceName } } = avForumsData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [avForumsData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (avNirvanaData?.addReview && !homeVideoReview.avNirvanaId) {
            const { addReview: { id, serviceName } } = avNirvanaData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [avNirvanaData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (avsForumData?.addReview && !homeVideoReview.avsForumId) {
            const { addReview: { id, serviceName } } = avsForumData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [avsForumData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (bluRayData?.addReview && !homeVideoReview.bluRayId) {
            const { addReview: { id, serviceName } } = bluRayData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [bluRayData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (bluRayAuthorityData?.addReview && !homeVideoReview.bluRayAuthorityId) {
            const { addReview: { id, serviceName } } = bluRayAuthorityData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [bluRayAuthorityData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (digitalBitsData?.addReview && !homeVideoReview.digitalBitsId) {
            const { addReview: { id, serviceName } } = digitalBitsData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [digitalBitsData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (doBluData?.addReview && !homeVideoReview.doBluId) {
            const { addReview: { id, serviceName } } = doBluData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [doBluData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (hidefDigestData?.addReview && !homeVideoReview.hidefDigestId) {
            const { addReview: { id, serviceName } } = hidefDigestData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [hidefDigestData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (highDefDiscNewsData?.addReview && !homeVideoReview.highDefDiscNewsId) {
            const { addReview: { id, serviceName } } = highDefDiscNewsData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [highDefDiscNewsData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (homeTheaterForumData?.addReview &&
            !homeVideoReview.homeTheaterForumId) {
            const { addReview: { id, serviceName } } = homeTheaterForumData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [homeTheaterForumData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (theaterByteData?.addReview && !homeVideoReview.theaterByteId) {
            const { addReview: { id, serviceName } } = theaterByteData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [theaterByteData, homeVideoReview, setSelectedIsReviewCreated]);
    useEffect(() => {
        if (whySoBluData?.addReview && !homeVideoReview.whySoBluId) {
            const { addReview: { id, serviceName } } = whySoBluData;
            setSelectedIsReviewCreated(id, serviceName);
        }
    }, [whySoBluData, homeVideoReview, setSelectedIsReviewCreated]);
    const onClearAll = useCallback(() => {
        // Reset all images
        resetImages();
        // Clear all reviews
        clearAll();
    }, [clearAll, resetImages]);
    return {
        onClearAll
    };
};
export default useAddEditHomeVideoReview;
